/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualCreditDto } from '../../models/backend-actual-credit-dto';
import { BackendActualCreditRequestDto } from '../../models/backend-actual-credit-request-dto';

export interface MonitoringActualsCreditsUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendActualCreditRequestDto;
}

export function monitoringActualsCreditsUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsCreditsUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualCreditDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsCreditsUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualCreditDto>;
    }),
  );
}

monitoringActualsCreditsUpdate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/credits/{id}/';
